import React from 'react';
import {
 Card, CardContent
} from 'shared/components/ui/card';
import {
 Button
} from 'shared/components/ui/button';
import {
 Sparkles, Download, Pencil, ArrowLeft
} from 'lucide-react';

interface SchemaMethodSelectProps {
    onSelectManual: () => void;
    onSelectImport: () => void;
    onSelectAI: () => void;
    onBack: () => void;
}

const methods = [
    {
        id: 'ai',
        title: 'Generate with AI',
        description: 'Fastest method. Describe your data, paste a JSON sample, or import from an API spec to auto-generate the entire schema.',
        icon: Sparkles,
    },
    {
        id: 'import',
        title: 'Import from Data Source',
        description: 'Connect to an existing database or API and import the structure of a table or endpoint.',
        icon: Download,
    },
    {
        id: 'manual',
        title: 'Create Manually',
        description: 'Build your schema from scratch, field by field.',
        icon: Pencil,
    },
];

const SchemaMethodSelect: React.FC<SchemaMethodSelectProps> = ({
    onSelectManual, onSelectImport, onSelectAI, onBack,
}) => {
    const handleClick = (id: string) => {
        if (id === 'manual') onSelectManual();
        if (id === 'import') onSelectImport();
        if (id === 'ai') onSelectAI();
    };

    return (
        <div className="flex flex-col gap-8 max-w-4xl mx-auto py-8">
            <div>
                <Button variant="ghost" size="sm" onClick={onBack} className="mb-4">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Back to Schemas
                </Button>
                <h2 className="text-2xl font-bold">How would you like to create your schema?</h2>
                <p className="text-muted-foreground mt-1">Choose the method that works best for you</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {methods.map((method) => (
                    <Card
                        key={method.id}
                        className="cursor-pointer transition-all hover:shadow-md hover:ring-2 hover:ring-primary/20"
                        onClick={() => handleClick(method.id)}
                    >
                        <CardContent className="p-6 flex flex-col items-center text-center gap-4 h-full">
                            <div className="rounded-full bg-muted p-4 mt-2">
                                <method.icon className="h-8 w-8" />
                            </div>
                            <div className="flex flex-col gap-2 flex-1">
                                <h3 className="font-semibold text-lg">{method.title}</h3>
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {method.description}
                                </p>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default SchemaMethodSelect;
